export default {
  produtoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  observacao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  },
  valor: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  operacao: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  diasAtraso: {
    value: null,
    maxlength: '70',
    required: false,
    state: null
  },
  risco: {
    value: '',
    maxlength: '1',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/product/modal/productmodal-form.js